export default __webpack_public_path__ + "static/media/Megosu - Lukas Bazle - 3.e8b6ca34.jpg";